/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FleetAuthenticateLogoutType } from './FleetAuthenticateLogoutType';
import {
    FleetAuthenticateLogoutTypeFromJSON,
    FleetAuthenticateLogoutTypeFromJSONTyped,
    FleetAuthenticateLogoutTypeToJSON,
    FleetAuthenticateLogoutTypeToJSONTyped,
} from './FleetAuthenticateLogoutType';

/**
 * 
 * @export
 * @interface FleetAuthenticatePeriod
 */
export interface FleetAuthenticatePeriod {
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticatePeriod
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof FleetAuthenticatePeriod
     */
    eventId: number;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticatePeriod
     */
    vehicleId: string;
    /**
     * 
     * @type {string}
     * @memberof FleetAuthenticatePeriod
     */
    userId: string;
    /**
     * 
     * @type {Date}
     * @memberof FleetAuthenticatePeriod
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof FleetAuthenticatePeriod
     */
    stopTime: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriod
     */
    receivedStartEvent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriod
     */
    receivedStopEvent: boolean;
    /**
     * 
     * @type {FleetAuthenticateLogoutType}
     * @memberof FleetAuthenticatePeriod
     */
    logoutType?: FleetAuthenticateLogoutType | null;
}



/**
 * Check if a given object implements the FleetAuthenticatePeriod interface.
 */
export function instanceOfFleetAuthenticatePeriod(value: object): value is FleetAuthenticatePeriod {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('stopTime' in value) || value['stopTime'] === undefined) return false;
    if (!('receivedStartEvent' in value) || value['receivedStartEvent'] === undefined) return false;
    if (!('receivedStopEvent' in value) || value['receivedStopEvent'] === undefined) return false;
    return true;
}

export function FleetAuthenticatePeriodFromJSON(json: any): FleetAuthenticatePeriod {
    return FleetAuthenticatePeriodFromJSONTyped(json, false);
}

export function FleetAuthenticatePeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetAuthenticatePeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventId': json['eventId'],
        'vehicleId': json['vehicleId'],
        'userId': json['userId'],
        'startTime': (new Date(json['startTime'])),
        'stopTime': (new Date(json['stopTime'])),
        'receivedStartEvent': json['receivedStartEvent'],
        'receivedStopEvent': json['receivedStopEvent'],
        'logoutType': json['logoutType'] == null ? undefined : FleetAuthenticateLogoutTypeFromJSON(json['logoutType']),
    };
}

export function FleetAuthenticatePeriodToJSON(json: any): FleetAuthenticatePeriod {
    return FleetAuthenticatePeriodToJSONTyped(json, false);
}

export function FleetAuthenticatePeriodToJSONTyped(value?: FleetAuthenticatePeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'eventId': value['eventId'],
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'startTime': value['startTime'].toISOString(),
        'stopTime': value['stopTime'].toISOString(),
        'receivedStartEvent': value['receivedStartEvent'],
        'receivedStopEvent': value['receivedStopEvent'],
        'logoutType': FleetAuthenticateLogoutTypeToJSON(value['logoutType']),
    };
}

